import axios from 'axios';
import routes from 'app/routes';

const prepareFormData = (values) => {
  const formData = new FormData();

  formData.append('title', values.title);
  formData.append('description', values.description);
  formData.append('category_ids', values.category_ids);
  formData.append('user_roles', values.userRoles);

  if (!Number.isNaN(values.position)) {
    formData.append('position', values.position);
  }
  formData.append('type_resource', values.typeResource);

  if (values.typeResource === 'file' && values.file !== undefined) {
    formData.append('file', values.file, values.file.name);
  }
  if (values.typeResource === 'url') {
    formData.append('url', values.url);
  }
  if (values.typeResource === 'vimeo') {
    formData.append('vimeo', values.vimeo);
    formData.append('manager_promote', values.managerPromote);
  }
  if (values.preview !== undefined) {
    formData.append('preview', values.preview, values.preview.name);
  }

  return formData;
};

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.resources.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', resources: resp.data.data });
      });
  },
  add: (dispatch, values, successCallback, errorCallback) => {
    const formData = prepareFormData(values);

    axios
      .post(routes.api.resources.create, formData)
      .then((resp) => {
        dispatch({ type: 'ADD', resource: resp.data.data });
        successCallback();
      }).catch((error) => {
        errorCallback(error.response.data);
      });
  },
  update: (dispatch, resourceId, values, successCallback, errorCallback) => {
    const formData = prepareFormData(values);

    axios
      .put(routes.api.resources.update(resourceId), formData)
      .then((resp) => {
        dispatch({ type: 'UPDATE', resource: resp.data.data });
        successCallback();
      }).catch((error) => {
        errorCallback(error.response.data);
      });
  },
  delete: (dispatch, resourceId) => {
    axios.delete(routes.api.resources.destroy(resourceId)).then(() => {
      dispatch({
        type: 'DELETE',
        resourceId,
      });
    });
  },
};
